import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UserDropdown from "../Dropdowns/UserDropdown";

// Mapa de títulos por segmento de ruta (para el breadcrumb dinámico)
const ROUTE_TITLES = {
  dashboard: "Panel de Control",
  proformas: "Proformas",
  invoices: "Facturas",
  "credit-note": "Notas de Crédito",
  "debit-note": "Notas de Débito",
  withholdings: "Retenciones",
  "dispatch-guide": "Guía de Despacho",
  salesBook: "Libro de Ventas",
  clients: "Empresas",
  endClients: "Clientes",
  contracts: "Contratos de Terceros",
  terceros: "Terceros", // (2026-05-17) FIND-5: faltaba — caía al fallback "Quantus Invoice"
  products: "Producto / Servicio",
  taxpayer: "Tipos de Contribuyentes",
  taxes: "Impuestos",
  "config-withholdings": "Retenciones",
  "config-exchange-rate-history": "Tasas de Cambio BCV",
  "config-payment-methods": "Métodos de Pago",
  auditlogs: "Registro de Auditoría",
  "company-users": "Usuarios",
  profile: "Mi Perfil",
};

export default function Navbar({ nombreUsuario, collapsed, setCollapsed }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  // Reloj en vivo (solo presentación; no afecta ninguna lógica existente)
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(id);
  }, []);

  // Breadcrumb dinámico desde la ruta
  const seg = location.pathname.split("/").filter(Boolean)[0] || "dashboard";
  const titulo = ROUTE_TITLES[seg] || "Quantus Invoice";

  const hora = now.toLocaleTimeString("es-VE", { hour: "2-digit", minute: "2-digit" });
  // (2026-05-20) Fecha completa con dia de la semana y año, capitalizada.
  // toLocaleDateString devuelve la primera letra en minuscula (es-*); la
  // mayusculizamos manualmente para mantener consistencia tipografica
  // ("Miercoles, 20 de mayo de 2026").
  const _fechaLarga = now.toLocaleDateString("es-VE", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const fecha = _fechaLarga.charAt(0).toUpperCase() + _fechaLarga.slice(1);

  return (
    <nav className="sticky top-0 w-full z-30">
      {/* Capas de fondo nocturno Sirius — clip SOLO el fondo, no el nav
          (si el nav tuviera overflow-hidden recortaría el dropdown). */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-sirius-night" />
        <div className="absolute inset-0 bg-sirius-mesh opacity-25" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-spark-500/40 to-transparent" />
      </div>

      <div className="relative w-full mx-auto flex justify-between items-center px-4 md:px-8 py-3.5">
        {/* IZQUIERDA: hamburguesa + breadcrumb */}
        <div className="flex items-center gap-3 min-w-0">
          <button
            onClick={() => setCollapsed(!collapsed)}
            className="md:hidden flex items-center justify-center w-9 h-9 rounded-lg text-white glass-panel focus:outline-none"
            data-tooltip={collapsed ? "Abrir menú" : "Cerrar menú"}
            data-tooltip-pos="bottom"
            aria-label="Menú"
          >
            <i className={`fas ${collapsed ? "fa-bars" : "fa-times"}`} />
          </button>

          <div className="min-w-0">
            <div className="flex items-center gap-2 text-[0.62rem] uppercase tracking-[0.18em] text-white/40">
              <span>Quantus Invoice</span>
              <i className="fas fa-chevron-right text-[0.5rem]" />
              <span className="text-spark-300">{seg}</span>
            </div>
            <h1 className="text-white text-lg md:text-xl font-display font-bold leading-tight truncate">
              {titulo}
            </h1>
          </div>
        </div>

        {/* DERECHA: reloj + UserDropdown
            (2026-05-20) Mas separacion entre el reloj y el avatar
            (gap-6 = 24px en vez de gap-3 = 12px) para que no se vean
            pegados. Fecha completa con dia de la semana. */}
        <div className="flex items-center gap-6 relative">
          <div className="hidden md:flex flex-col items-end px-3.5 py-1.5 rounded-xl glass-panel">
            <span className="text-white text-sm font-semibold leading-none">{hora}</span>
            <span className="text-white/55 text-[0.62rem] tracking-wide mt-1 whitespace-nowrap">{fecha}</span>
          </div>

          <UserDropdown
            nombreUsuario={nombreUsuario}
            onLogout={handleLogout}
          />
        </div>
      </div>
    </nav>
  );
}
